import { id } from '@monorepo/tools/src/lib/types/primitives';
import { CrudEndpoint } from './crud.endpoint';

export class NotificationsEndpoint extends CrudEndpoint {
	constructor() {
		super('notifications');
	}

	private scopedBaseUrl(accountId?: id | null) {
		return accountId ? `${this.baseUrl}/account/${accountId}` : this.baseUrl;
	}

	list(accountId?: id | null) {
		return this.scopedBaseUrl(accountId);
	}

	markAsRead(id: number, accountId?: id | null) {
		return `${this.scopedBaseUrl(accountId)}/${id}/read`;
	}

	markAllAsRead(accountId?: id | null) {
		return `${this.scopedBaseUrl(accountId)}/read-all`;
	}
}
